import { render, staticRenderFns } from "./ContactOverviewDialog.vue?vue&type=template&id=41d40a2f&scoped=true"
import script from "./ContactOverviewDialog.vue?vue&type=script&lang=js"
export * from "./ContactOverviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactOverviewDialog.vue?vue&type=style&index=0&id=41d40a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d40a2f",
  null
  
)

export default component.exports